import { render, staticRenderFns } from "./ClientsContactList.vue?vue&type=template&id=1dad002f&scoped=true&"
import script from "./ClientsContactList.vue?vue&type=script&lang=js&"
export * from "./ClientsContactList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dad002f",
  null
  
)

export default component.exports